export enum Environment {
	Development = 'development',
	Test = 'test',
	Acceptance = 'acceptance',
	Production = 'production',
}
